import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../../menu/services';
import { ComboCreateDishSelectPage } from '../../combo-create/combo-create-dish-select/combo-create-dish-select';
import { ComboCreatePricePage } from '../../combo-create/combo-create-price/combo-create-price';
import { ComboCreateTitlePage } from '../../combo-create/combo-create-title/combo-create-title';
import { ComboServices } from '../../services';

/**
 * Generated class for the MenuCreateCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-template-list',
  templateUrl: 'combo-template-list.html',
})

export class ComboTemplateListPage {

  logo_url: any;

  constructor(
    public menuServices: MenuServices,
    public globals: Globals,
    public navCtrl: NavController,
    public comboServices: ComboServices) {

  }

  editHeader() {
    this.navCtrl.push(ComboCreateTitlePage, {
      type: this.menuServices.menu_tmp.style,
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      template_name: this.menuServices.menu_tmp.template_name,
      tags: this.menuServices.menu_tmp.tags,
      title_es: this.menuServices.menu_tmp.title_es,
      title_ca: this.menuServices.menu_tmp.title_ca,
      title_en: this.menuServices.menu_tmp.title_en,
      title_de: this.menuServices.menu_tmp.title_de,
      title_it: this.menuServices.menu_tmp.title_it,
      title_fr: this.menuServices.menu_tmp.title_fr,
      subtitle_es: this.menuServices.menu_tmp.subtitle_es,
      subtitle_ca: this.menuServices.menu_tmp.subtitle_ca,
      subtitle_en: this.menuServices.menu_tmp.subtitle_en,
      subtitle_de: this.menuServices.menu_tmp.subtitle_de,
      subtitle_it: this.menuServices.menu_tmp.subtitle_it,
      subtitle_fr: this.menuServices.menu_tmp.subtitle_fr,
      reference: this.menuServices.menu_tmp.reference,
      combo_name: this.comboServices.comboTitleByLang(this.menuServices.menu_tmp),
    });
  }

  editElements(section_index) {
    this.navCtrl.push(ComboCreateDishSelectPage, {
      type: this.menuServices.menu_tmp.style,
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      section: section_index,
      section_complete: this.menuServices.menu_tmp.sections,
      new: false,
    });
  }

  editFooter() {
    //
    this.menuServices.edit_type = 'footer';
    //
    this.navCtrl.push(ComboCreatePricePage, {
      update: true,
      combo_uid: this.menuServices.menu_tmp.UID,
      price: this.menuServices.menu_tmp.price,
      price_takeaway: this.menuServices.menu_tmp.price_takeaway,
      extra_price: this.menuServices.menu_tmp.extra,
      footer: this.menuServices.menu_tmp.footer,
      type: this.menuServices.menu_tmp.style,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-templates/combo-template-list/combo-template-list.ts